import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import { AccessRoute, AuthProtected } from "./AuthProtected";
import { adminAuthProtectedRoutes, customerAuthProtectedRoutes, publicRoutes } from "./allRoutes";
import { ToastContainer } from "react-toastify";
const availableAuthRoutesPath = [
  ...adminAuthProtectedRoutes,
  //...customerAuthProtectedRoutes,
]
const Index = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1200}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Routes> {/* Wrap Routes here */}
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            }
          />
        ))}

        {/* Auth Protected Routes */}
        {availableAuthRoutesPath.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <VerticalLayout>
                  <AccessRoute component={route.component} path={route.path} roles={route.roles} />
                </VerticalLayout>
              </AuthProtected>
            }
          />
        ))}
      </Routes>
    </>
  );
};

export default Index;
